import React, { Dispatch, ReactNode } from "react";

interface Props {
    value: string;
    label?: string;
    children?: ReactNode
    setValues: Dispatch<React.SetStateAction<Set<string>>>;
    values: Set<string>;
}
const Checkbox = ({ label, value, setValues, values, children }: Props) => {
    return (
        <div className={"flex gap-2"}>
            <input type = "checkbox" name={value} checked={values.has(value)} onChange={() => {
                setValues((prev) => {
                    const next = new Set(prev);
                    if (next.has(value))
                        next.delete(value);
                    else
                        next.add(value);
                    return next;
                });
            }}
            />
            { label && <label>{label}</label> }
            {children && children}
        </div>
    );
};

export default Checkbox;